import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/leave-management-system/leave-history/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "leave-history" entry is kept); the seo block below is a fallback.

export const leaveHistory: ContentPage = {
  slug: "leave-management-system/leave-history",
  template: "hrmsFeature",
  seo: {
    title: "Leave History - Detailed Records of Past Leaves",
    description: "Track and review detailed records of all past leaves with our Leave History tool. Ensure transparency and easy access to leave data for employees and managers.",
    keywords: [
      "leave history records",
      "employee leave history",
      "HR leave logs",
      "past leave tracking",
      "leave record management",
      "detailed leave records",
    ],
    ogImage: "/assets/data/seoimages/leave-history.webp",
  },
  leaf: {
    hero: {
      caption: "Leave History",
      title: "Comprehensive Leave Records at Your Fingertips",
      description: "Access detailed records of all past leaves, ensuring transparency and easy reference for both employees and HR managers.",
      h1: "title",
    },
    split: {
      title: "Transparent Leave History for Improved Tracking",
      bullets: [
        { title: "Leave Balance Tracking", description: "Easily monitor used and remaining leave balances." },
        { title: "Leave Approval History", description: "View detailed records of approved leave." },
        { title: "Custom Leave Categories", description: "Define leave types based on company policies." },
        { title: "Leave History Reports", description: "Generate reports for past leave data and trends." },
      ],
      image: "/assets/images/img/product/hrms/leavems/leave-history.webp",
      imageAlt: "leave-history",
    },
    cardsHeading: {
      title: "Choose the Best HRMS for Your Business",
      description: "GetBiz Solutions HRMS is designed to meet the unique needs of your business, offering flexible, scalable, and user-friendly HR management solutions.",
    },
    cards: [
      {
        title: "Leave Policy & Allocation",
        href: "/hrms-software/leave-management-system/leave-policy-allocation",
        description: "Create and manage leave policies tailored to your organization’s needs. Allocate leaves based on roles, seniority, and more.",
        image: "/assets/images/img/product/hrms/leavems/leave_policy_and_allocation.webp",
        imageAlt: "leave_policy_and_allocation",
      },
      {
        title: "Leave Reports",
        href: "/hrms-software/leave-management-system/leave-reports/",
        description: "Gain valuable insights into employee leave trends with detailed reports and analytics, ensuring better workforce planning and policy adjustments.",
        image: "/assets/images/img/product/hrms/leavems/leave-reports.webp",
        imageAlt: "leave_reports_analytics",
      },
      {
        title: "Leave Accrual Details",
        href: "/hrms-software/leave-management-system/leave-accrual-details",
        description: "Automate the calculation of leave accruals to ensure accurate and fair leave tracking, eliminating manual errors.",
        image: "/assets/images/img/product/hrms/leavems/leave_accrual_details.webp",
        imageAlt: "leave_accrual_details",
      },
      {
        title: "Easy Approval",
        href: "/hrms-software/leave-management-system/leave-approval/",
        description: "Facilitate quick and easy leave request approvals or declines with a user-friendly workflow, keeping your HR processes efficient.",
        image: "/assets/images/img/product/hrms/leavems/easy_approval_decline.webp",
        imageAlt: "easy_approval_decline",
      },
    ],
    testimonials: {
      title: "What Our Customers Say",
      description: "Our clients consistently praise the design and functionality of our templates.",
    },
    bookDemoTitle: "Discover Leave History Features Book a Demo",
    relatedBlogsKeyword: "benefits-of-automated-leave-system",
    metaKey: "leave-history",
  },
  sections: [],
};
